"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUSINESS_IDENTIFIERS_REGEXES = void 0;
// TODO(sasalatart): add support for more countries
exports.BUSINESS_IDENTIFIERS_REGEXES = new Map([['US', /^\d{9}$/]]);
//# sourceMappingURL=business-identifier.js.map